/*
Important
This file is used only for the vue3 application.
Changes made here will not be reflected in the Vue2 application.
You need to make changes in the vue3 file also
Vue2 file: Velocity.PrimaryOffersites.Web\wwwroot\store\modules\PaymentSettings.js
Any clarifications contact Leela Directly
*/

import { defineStore } from 'pinia';
import {
  GET_ALL_FORD_DIRECT_QUALIFIED_INCENTIVES,
  GET_CUSTOMIZED_PAYMENTS,
  GET_MILES_DATA,
  GET_PAGESTATE_DATA,
  GET_PAYMENT_SETTINGS,
  GET_SMARTPATH_UNLOCK_SETTINGS,
  REBATE_LABEL,
  SET_CONDITIONAL_REBATE_INCENTIVES,
  SET_MILES_DATA,
  SET_PAYMENT_SETTINGS,
  FINAL_PRICE_LABEL,
  SET_AIS_REBATES,
  DISCOUNT_LABEL,
} from '../../../../store/types';
import ShiftDigitalContainer from '../../Events/ShiftDigital/ShiftDigitalContainer';
import { Payments } from '../../Services/Payments/Payments';
import { FINANCE, LEASE, CASH } from '../../../../js/constants/constants';
import { PAYMENT_CONFIGURATION_DETAILS } from '../../../../js/constants/expresspaymentconstants';
import { adminDefaultPaymentSelectionSettings } from '../../Services/Payments/PaymentsService';

export const usePaymentSettingsStore = defineStore('paymentSettings', {
  state: () => ({
    settings: {},
    feesData: {
      totalFeeUsed: 0,
      totalFeeNew: 0,
    },
    deliveryType: {
      lease: {},
      cash: {},
      finance: {},
    },
    shiftDigitalDone: false,
    paymentsFeesData: '',
    expressPaymentsFeesData: '',
    isVehicleDetailsPage: false,
    completePaymentsData: '',
    showTransactPopup: false,
    interestedComponentType: '',
    showTransactPopupIframe: false,
    settingssuccess: false,
    vdpContactFromTransact: false,
    vdpContactFromPaymentPanel: false,
    showVdpContactUS: false,
    showTextMeQuote: false,
    showRequestVideo: false,
    showDownPaymentMessage: false,
    vdpContactUsZindex: false,
    unlockEPriceCookie: true,
    unlockEPriceCookieVin: true,
    unlockCashPriceDiscount: true,
    transactUnlockFormModal: true,
    showOverLayPaymentsData: '',
    cashTradeValue: 0,
    cashPriceDiscountValue: 0,
    selectedPaymentOption: LEASE,
    miles: [],
    leasedata: '',
    totalLeaseData: '',
    leaseTerms: [],
    financeTerms: [],
    gotpayments: false,
    financedata: '',
    showLoading: false,
    showLeaseTab: false,
    showFinanceTab: false,
    pageStateKey: '',
    paymentConfiguration: PAYMENT_CONFIGURATION_DETAILS,
    previousSelectedValues: {
      lease: {
        selectedPayment: '',
        mileage: '',
        downPayment: '',
        tradeValue: '',
        term: '',
      },
      finance: {
        selectedPayment: '',
        mileage: '',
        downPayment: '',
        tradeValue: '',
        term: '',
      },
    },
    interestedActiveComponent: '',
    ctaActiveComponent: '',
    lockInPaymentType: '',
    ctaActiveComponentProps: {},
    formHeading: '',
    formButtonLabel: '',
    formActionName: '',
    formButtonColor: '',
    formButtonFontColor: '',
    isTransact: false,
    smartPathUnlockStatus: '',
    fordDirectQualifiedIncentives: {},
    conditionalRebateIncentives: {},
    rebateLabel: '',
    discountLabel: '',
    finalPriceLabel: '',
    smartpathDealerDisclaimer: '',
    smartpathDDOADisclaimer: '',
    softPullVehiclePrice: 0,
    getSoftPullSettings: {},
    feesResults: '',
    aisRebates: {},
    standardFinanceVehicleData: {},
    paymentCalculatorInteractionCount: 0,
    sendToPhoneVdv: false,
    vdpPrintPriceDetails: '',
    vdpPrintCfp: '',
    alternatePayments: {
      rebates: {
        label: '',
        value: '',
      },
      fee: {
        label: '',
        value: '',
      },
      tax: {
        label: '',
        value: '',
      },
    },
    unlockCtaDiscountData: {},
    runBuggySettings: {
      placement: [],
      inventoryTypes: [],
      paymentTypes: [],
    },
  }),
  getters: {
    formatRunBuggyResponse: (state) => {
      let inventoryType = window.inventoryType?.toLowerCase?.() || '';
      let selectedPaymentOption = state.selectedPaymentOption?.toLowerCase?.() || '';
      return {
        placement: {
          vdp: state.runBuggySettings.placement.includes('vdp'),
          transact: state.runBuggySettings.placement.includes('transact'),
        },
        inventoryTypes: {
          new: state.runBuggySettings.inventoryTypes.includes('new') && inventoryType === 'new',
          used: state.runBuggySettings.inventoryTypes.includes('used') && inventoryType === 'used',
          cpo: state.runBuggySettings.inventoryTypes.includes('cpo') && inventoryType === 'cpo',
        },
        paymentTypes: {
          lease:
            state.runBuggySettings.paymentTypes.includes('lease') &&
            selectedPaymentOption === 'lease',
          finance:
            state.runBuggySettings.paymentTypes.includes('finance') &&
            selectedPaymentOption === 'finance',
          cash:
            state.runBuggySettings.paymentTypes.includes('cash') &&
            selectedPaymentOption === 'cash',
        },
      };
    },
    getSelectedPaymentData: (state) => {
      if (state.selectedPaymentOption?.toLowerCase?.() === LEASE.toLowerCase()) {
        return state.leasedata;
      }
      if (state.selectedPaymentOption?.toLowerCase?.() === FINANCE.toLowerCase()) {
        return state.financedata;
      }
      return '';
    },
    getUnlockPriceCookie: (state) => {
      if (state.unlockEPriceCookie || state.showOverLayPaymentsData) {
        if (
          state.showOverLayPaymentsData.enableOverleyOnVDP ||
          state.showOverLayPaymentsData.enableOverleyOnTransact
        ) {
          let cookieValue = '';
          let cookie = document.cookie.indexOf('unLockPriceCookie') >= 0;
          if (cookie) {
            let cookieName = 'unLockPriceCookie';
            let name = cookieName + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let cookieList = decodedCookie.split(';');
            for (let c of cookieList) {
              while (c.startsWith(' ')) {
                c = c.substring(1);
              }
              if (c.startsWith(name)) {
                cookieValue = c.substring(name.length, c.length);
              }
            }
            if (cookieValue.trim() === window.tid?.trim()) {
              state.unlockEPriceCookie = false;
              return false;
            } else {
              state.unlockEPriceCookie = true;
              return true;
            }
          } else {
            state.unlockEPriceCookie = true;
            return true;
          }
        }
      } else {
        state.unlockEPriceCookie = false;
        return false;
      }
    },
    getStandardFinanceVehicleData: (state) => {
      if (state.selectedPaymentOption?.toLowerCase?.() === FINANCE.toLowerCase()) {
        return state.standardFinanceVehicleData?.Disclaimers;
      }
      return '';
    },
  },
  actions: {
    [SET_MILES_DATA](payload) {
      let miles = [];

      for (let mile of payload.MileageAllowances) {
        miles.push(mile.Mileage);
      }
      this.miles = miles;
    },
    async [GET_PAYMENT_SETTINGS](payload) {
      this.settings = payload;
      this.settingssuccess = true;

      let finalPriceValue = this.settings.yourPrice;

      if (this.isVehicleDetailsPage) {
        let shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
        window.displayedFinalPrice = Payments.conventStringToNumber(finalPriceValue);
        if (shiftDigital && typeof shiftDigital.vehicleDetailsPageView === 'function') {
          shiftDigital.vehicleDetailsPageView(
            window.vin,
            Payments.conventStringToNumber(finalPriceValue)
          );
        }
      }
      // const deliveryFee = (context.state.deliveryType && context.state.deliveryType.fare) || 0;
      Payments.getPayments(0, 0, '', 0, '', 0, 0).then(async (response) => {
        this.showLoading = false;

        this.completePaymentsData = response.PaymentCollection;

        let leasefinancedata = Payments.formatPayments(response, '', payload);

        let leaseArray = Payments.extractLeaseData(response);
        let leaseFinanceTerms = Payments.getLeaseFinanceTerms(response);

        this.leaseTerms = leaseFinanceTerms.leaseTerms;
        this.financeTerms = leaseFinanceTerms.financeTerms;
        this.totalLeaseData = leaseArray;

        let leaseData = '';
        let financeData = '';

        let paymentsMessage = response.Message.toLowerCase();
        if (response?.PaymentCollection?.length) {
          this.showFinanceTab = true;
          this.showLeaseTab = true;
        }

        let feesResults = await Payments.getFeesResults();
        if (feesResults) {
          this.feesResults = feesResults;
        }

        if (paymentsMessage !== '') {
          this.showFinanceTab = false;
          this.showLeaseTab = false;
          this.selectedPaymentOption = CASH;
          this.gotpayments = true;

          return;
        }

        try {
          this.paymentsFeesData = response.FeesAndTaxesCollection;
        } catch (e) {
          console.log(e);
        }

        if (leasefinancedata.length) {
          this.leasedata = leasefinancedata[0][0];
          this.financedata = leasefinancedata[1][0];

          if (leasefinancedata[0][0]) {
            this.previousSelectedValues['lease'] = {
              selectedPayment: 'lease',
              mileage: Payments.conventStringToNumber(leasefinancedata[0][0].MileageAllowance),
              downPayment: Payments.conventStringToNumber(leasefinancedata[0][0].Downpayment),
              tradeValue: 0,
              term: leasefinancedata[0][0].Term,
            };
          }

          if (leasefinancedata[1][0]) {
            this.previousSelectedValues['finance'] = {
              selectedPayment: 'finance',
              downPayment: Payments.conventStringToNumber(leasefinancedata[1][0].Downpayment),
              tradeValue: 0,
              term: leasefinancedata[1][0].Term,
            };
          }

          let isUsedVehicle = Payments.isUsedVehicle(payload);

          if (!isUsedVehicle) {
            if (Payments.isNewVehicleLeaseWindowAvailable()) {
              leaseData = leasefinancedata[0][0];
            }

            if (Payments.isNewVehicleFinanceWindowAvailable()) {
              financeData = leasefinancedata[1][0];
            }
          } else if (Payments.isUsedVehicleFinanceWindowAvailable()) {
            financeData = leasefinancedata[1][0];
          } else {
            //No action needed for other cases
          }
          this.showTransactPopup = true;
        }

        this.showLeaseTab = Payments.isLeaseTabVisible(payload);

        if (!this.settings.isLeasePaymentsActive) {
          this.showLeaseTab = false;
        }

        if (!this.settings.isFinancePaymentsActive) {
          this.showFinanceTab = false;
        }

        let isUsedVehicle = Payments.isUsedVehicle(payload);

        if (!isUsedVehicle) {
          if (!Payments.isNewVehicleLeaseWindowAvailable()) {
            this.showLeaseTab = false;
          }

          if (!Payments.isNewVehicleFinanceWindowAvailable()) {
            this.showFinanceTab = false;
          }
        } else if (!Payments.isUsedVehicleFinanceWindowAvailable()) {
          this.showFinanceTab = false;
        } else {
          //No action needed for other cases
        }

        if (!leasefinancedata[0][0]) {
          this.showLeaseTab = false;
        }

        if (!leasefinancedata[1][0]) {
          this.showFinanceTab = false;
        }

        if (window.pageStateKey) {
          this.pageStateKey = window.pageStateKey;
          this.showLoading = true;

          this[GET_PAGESTATE_DATA]({
            paymentsettings: payload,
          });
        } else {
          let selectedOption = Payments.getSelectedPaymentOption(payload, leaseData, financeData);
          this.selectedPaymentOption = selectedOption;
        }

        if (Payments.checkAudiPaymentDiscountLimits(this.settings, leasefinancedata[1][0])) {
          this.showFinanceTab = false;
          this.showLeaseTab = false;
          this.selectedPaymentOption = CASH.toLowerCase();
        }

        if (window.aiCall) {
          this.selectedPaymentOption = CASH.toLowerCase();
        }

        adminDefaultPaymentSelectionSettings(leaseData, financeData);
        this.gotpayments = true;
      });
    },
    [SET_PAYMENT_SETTINGS](payload) {
      let styleid = window.styleId;
      let vin = window.vin;
      if (vin) {
        styleid = '';
      }

      let accountId = window.vdpAccountId ? window.vdpAccountId : window.accountId;

      axios
        .get(
          `${window.ApiBaseUrl}/Inventory/getPaymentSettingDetails?accountId=${accountId}&vin=${vin}&styleid=${styleid}`
        )
        .then((response) => {
          this[GET_PAYMENT_SETTINGS](response.data);
        });
    },
    [GET_MILES_DATA](payload) {
      const accountId = window.vdpAccountId ? window.vdpAccountId : window.accountId;
      axios
        .get(
          `${atob(
            window.portalUrl
          )}/OfferManager/service/OffermanagerApi/offerlogix/MileageAllowance/AccountID/${accountId}`
        )
        .then((response) => {
          this[SET_MILES_DATA](response.data);
        });
    },

    [GET_PAGESTATE_DATA](payload) {
      axios
        .get(`${window.ApiBaseUrl}/PageState/get?pageKey=${window.pageStateKey}`)
        .then((response) => {
          this.showLoading = false;

          if (response.data) {
            this.paymentConfiguration = {
              ...this.paymentConfiguration,
              ...response.data.paymentCalculator,
            };

            this.selectedPaymentOption = '';

            if (response.data.paymentCalculator.selectedPayment === CASH) {
              this.selectedPaymentOption = CASH;
              this.cashTradeValue = response.data.paymentCalculator.tradeValue;
            } else {
              this[GET_CUSTOMIZED_PAYMENTS]({
                paymentsdata: response.data.paymentCalculator,
                paymentsettings: payload,
              });
            }
          }
        });
    },
    [GET_CUSTOMIZED_PAYMENTS](payload) {
      this.showLoading = true;

      // const deliveryFee = (context.state.deliveryType && context.state.deliveryType.fare) || 0;
      Payments.getPayments(
        1,
        payload.paymentsdata.downPayment,
        payload.paymentsdata.selectedPayment,
        payload.paymentsdata.term,
        payload.paymentsdata.mileage,
        payload.paymentsdata.tradeValue,
        0
      ).then((response) => {
        this.showLoading = false;
        this.gotpayments = true;

        let data = Payments.filterPaymentsByTerm(response, payload.paymentsdata.term);

        if (LEASE.toLowerCase() === payload.paymentsdata.selectedPayment.toLowerCase()) {
          this.selectedPaymentOption = LEASE;

          if (data) {
            this.leasedata = data;
          }
        } else if (FINANCE.toLowerCase() === payload.paymentsdata.selectedPayment.toLowerCase()) {
          this.selectedPaymentOption = FINANCE;

          if (data) {
            this.financedata = data;
          }
        } else {
          // No action needed for other cases.
        }
      });
    },
    [GET_SMARTPATH_UNLOCK_SETTINGS](payload) {
      if (window.enableUnlockSmartPrice) {
        SmartPathService.smartPathUnlockStatus()
          .then((res) => {
            if (res?.data?.length && res?.data?.includes(window.oemCode)) {
              this.smartPathUnlockStatus = true;
            } else {
              this.smartPathUnlockStatus = false;
            }
          })
          .catch((e) => {
            this.smartPathUnlockStatus = false;
          });
      } else {
        this.smartPathUnlockStatus = true;
      }
    },
    [GET_ALL_FORD_DIRECT_QUALIFIED_INCENTIVES](payload) {
      this.fordDirectQualifiedIncentives = payload;
    },
    [SET_CONDITIONAL_REBATE_INCENTIVES](payload) {
      this.conditionalRebateIncentives = payload;
    },
    [REBATE_LABEL](payload) {
      this.rebateLabel = payload;
    },
    [DISCOUNT_LABEL](payload) {
      this.discountLabel = payload;
    },
    [FINAL_PRICE_LABEL](payload) {
      this.finalPriceLabel = payload;
    },
    [SET_AIS_REBATES](payload) {
      this.aisRebates = payload;
    },
    updateAlternatePayment(payload) {
      state.alternatePayments[payload.key]['label'] = payload.label;
      state.alternatePayments[payload.key]['value'] = payload.value;
    },
  },
});
